import { getDeviceInfo } from './utils'
let deviceInfo = getDeviceInfo()
window.jsbridgeCallbackId = 0

function bridgeInit(callback) {
    if (deviceInfo.ios) {
        if (window.WebViewJavascriptBridge) { return callback(window.WebViewJavascriptBridge); }
        if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback); }
        window.WVJBCallbacks = [callback];
        var WVJBIframe = document.createElement('iframe');
        WVJBIframe.style.display = 'none';
        WVJBIframe.src = 'https://__bridge_loaded__';
        document.documentElement.appendChild(WVJBIframe);
        setTimeout(function () { document.documentElement.removeChild(WVJBIframe) }, 0)
    }
    if (deviceInfo.android) {
        if (window.WebViewJavascriptBridge) {
            callback(window.WebViewJavascriptBridge)
        }
    }
}

var JSBridge = {
    version:"1.1.1",
    registerHandler:function(name, arg) {
        if (deviceInfo.ios) {
            bridgeInit(function (bridge) {
                bridge.registerHandler("jsbridgeWeb" + name, function (data, responseCallback) {
                    console.log('ios call',data)
                    responseCallback(arg)
                })
            })
        }

        if (deviceInfo.android) {
            window["jsbridgeWeb" + name] = (function() {
              return  JSON.stringify(arg === undefined || arg == null ? {} : arg)
            })();
        }
    },
    // web调用native
    callHandler:function(name, arg, cb) {
        if (deviceInfo.ios) {
            bridgeInit(function (bridge) {
                bridge.callHandler(name, arg, cb)
            })
        }else if(deviceInfo.android) {
            var args = {
                params: arg === undefined || arg == null ? {} : JSON.stringify(arg)
            };
            if (typeof cb === 'function') {
                const cbName = 'jsbridge_callback_' + window.jsbridgeCallbackId++;
                window[cbName] = cb;
                args['cbName'] = cbName;
            }
            bridgeInit(function (bridge) {
                bridge.call(name, JSON.stringify(args));
            });
        } else {
            if (typeof cb === 'function') {

                cb({
                    code: 1,
                    message: '不在app内',
                    data: null
                })
            }
        }
    }
}

var BridgeNativeMethods = {
    getTokenPromise() {
        return new Promise(resolve => {
            JSBridge.callHandler('getToken', null, res => {
                resolve(res)
            })
        })    
    },
    getToken(cb) {
        JSBridge.callHandler('getToken', null, res => {
            cb(res)
        })
    },
    getUserInfo(cb) {
        JSBridge.callHandler('getUserInfo', null, res => {
            cb(res)
        })
    },
    getUserInfoPromise() {
        return new Promise(reslove => {
            JSBridge.callHandler('getUserInfo', null, res => {
                reslove(res)
            })
        })
    },
    updateToken(token) {
        JSBridge.callHandler('updateToken', {'token':token})
    },
    getAppVersion(cb) {
        JSBridge.callHandler('getAppVersion', null, res => {
            cb(res)
        })
    },
    logout() {
        JSBridge.callHandler('logout')
    },
    setTitle(title) {
        JSBridge.callHandler('setTitle', {'title':title})
    },
    showToast(text) {
        JSBridge.callHandler('showToast', {'text':text})
    },
    showLoading() {
        JSBridge.callHandler('showLoading')
    },
    hideLoading() {
        JSBridge.callHandler('hideLoading')
    },
    navigateHome() {
        JSBridge.callHandler('navigateHome', null)
    },
    navigateBack() {
        JSBridge.callHandler('navigateBack',null)
    },
    navigateVoteResult(data) {
        JSBridge.callHandler('navigateVoteResult',{'data':data})
    },
    navigateQuestionnaireResult(data) {
        JSBridge.callHandler('navigateQuestionnaireResult',{'data':data})
    },
    payZhifubao(data,cb) {
        JSBridge.callHandler('payZhifubao', {'data':data},res=> cb(res))
    },
    payWeixin(data,cb) {
        JSBridge.callHandler('payZhifubao', {'data':data},res => cb(res))
    },
    share(data,cb) {
        JSBridge.callHandler('share',{'data':data}, res=> cb(res))
    },
}

function initBridgeWebMethods() {
    JSBridge.registerHandler("Version", {
        code: 0,
        message: '',
        data: {
            "version": JSBridge.version
        }
    })
}

export {JSBridge, BridgeNativeMethods,initBridgeWebMethods}